/*global google*/
    
import * as React from 'react';
import { PolyLine } from '../googlemaps/polyline';
import { FlightLegViewModel} from '../../models/flightleg';
import { MapComponentProps } from '../googlemaps/map';
import { withFlightAwareTracking, FlightAwareFlightLeg } from '../../signalr/withflightawaretracking';
import { AircraftMarker } from './aircraftmarker';
import { mapLocation } from '../googlemaps/location';

export interface FlightLegProps extends FlightLegViewModel, FlightAwareFlightLeg, MapComponentProps {
    aircraftImage?: string;
    planColor?: string;
    planWeight?: number;
    flightColor?: string;
    flightWeight?: number;
    legColor?: string;
    legWeight?: number;
    children?: never;
    showPlan?: boolean;
    aircraftEvents?: DOMEvents<HTMLImageElement>
}

export class FlightLeg extends React.PureComponent<FlightLegProps> {

    static defaultProps = {
        planColor: "#3276b1",
        planWeight: 2,
        flightColor: "#ffffff",
        flightWeight: 2,
        legColor: "#ff3b30",
        legWeight: 2,
        showPlan: true,
        aircraftEvents: {}
    };

    static displayName = "Map.FlightLeg";

    componentDidMount() {
        const {
            arrivalLocation,
            departureLocation,
            map,
            position
        } = this.props;

        if (arrivalLocation && departureLocation) {
            let bounds = new google.maps.LatLngBounds();
            bounds.extend(mapLocation(arrivalLocation));
            bounds.extend(mapLocation(departureLocation));
            map.fitBounds(bounds);
        } else if (position) {
            map.setCenter(mapLocation(position))
            map.setZoom(5);
        }
    }

    componentDidUpdate(prevProps: FlightLegProps) {
        if (!((prevProps.arrivalLocation && prevProps.departureLocation) || prevProps.position)) {
            if (this.props.position) {
                this.props.map.setCenter(mapLocation(this.props.position));
                this.props.map.setZoom(5);
            }
        }
    }

    render() {
        const {
            map,
            aircraftImage,
            plan,
            flight,
            departureLocation,
            arrivalLocation,
            tailNumber,
            position,
            aircraftTypeName,
            aircraftTypeCode,
            departure,
            arrival,
            flightAwareEstimatedArrivalTimeLocal,
            flightAwareEstimatedArrivalTimeUTC,
            scheduledArrivalTimeLocal,
            scheduledArrivalTimeUTC,
            planColor,
            planWeight,
            flightColor,
            flightWeight,
            legColor,
            legWeight,
            showPlan,
            aircraftEvents
        } = this.props;

        return <>
            {showPlan && plan && (plan.length > 0) && <PolyLine map={map} path={plan} strokeColor={planColor} strokeWeight={planWeight} zIndex={-1} />}
            {flight && <PolyLine map={map} path={flight} strokeColor={flightColor} strokeWeight={flightWeight} />}
            {showPlan && plan && !plan.length && departureLocation && arrivalLocation && <PolyLine map={map} path={[departureLocation, arrivalLocation]} geodesic={true} strokeColor={legColor} strokeWeight={legWeight} zIndex={-1} />}
            {position && <AircraftMarker map={map} position={position} tailNumber={tailNumber} aircraftType={aircraftTypeName} aircraftTypeCode={aircraftTypeCode} departure={departure} arrival={arrival} flightAwareEstimatedArrivalTimeLocal={flightAwareEstimatedArrivalTimeLocal} flightAwareEstimatedArrivalTimeUTC={flightAwareEstimatedArrivalTimeUTC} scheduledArrivalTimeLocal={scheduledArrivalTimeLocal} scheduledArrivalTimeUTC={scheduledArrivalTimeUTC} aircraftImage={aircraftImage} {...aircraftEvents} />}
        </>
    }
}


export const TrackedFlightLeg = withFlightAwareTracking(FlightLeg);